module.exports = __webpack_public_path__ + "img/fst1.720ac631.png";